class HistoryOfContent {
	constructor(container: HTMLElement) {
		container.querySelector('.show-all button')?.addEventListener('click', () => {
			container.classList.add('is-full-visible');
			container.querySelector('.show-all').remove();
		});
	}
}

document.querySelectorAll('.history-of-content').forEach((element: HTMLElement) => {
	new HistoryOfContent(element);
});
